<app-toast [message]="toast.message"></app-toast>

<div class="row">

  <div class="col-2 ps-0 sidebar">
    <app-sidebar [items]="menuItems" [current]="currentContent"></app-sidebar>
  </div>
  <div class="col-10 px-0">
    @if (currentContent === 'search') {
      <div class="card border-0">
        <h4 class="card-header border-0">
          Search
        </h4>
        <div class="card-body">
          <p>Search across 1M+ tweets and 10K+ documents from Camera, Senato, European Parliament and <a data-bs-toggle="modal" data-bs-target="#other-sources-info-modal">other sources <i class="fa fa-question-circle"></i></a>.</p>
          <p class="small bg-light border rounded-lg px-3 pt-2 pb-1">
            Input boxes support the following <i>operators</i>:<br>
            - double quotes <code>""</code> for exact phrase match;<br>
            - wildcard operator <code>*</code> for partial word match;<br>
            - proximity operator <code>"..."~N</code> for max distance between words;<br>
            - minus operator <code>-</code> for exclusion;<br>
            - parenthesis <code>()</code> to create a block of words;<br>
            - the <code>AND</code> operator to match words that must occur with other words in the same document.<br>
          </p>
          <a data-bs-toggle="modal" data-bs-target="#search-query-info-modal">Show me some examples. <i class="fa fa-info-circle"></i></a>
          <hr>
            <form (ngSubmit)="search()">
              <div class="row">
                <div class="form-group col-md-8">
                  <label>Keywords
                    <i class="fa fa-question-circle" data-bs-toggle="modal" data-bs-target="#search-query-info-modal"></i>
                  </label>
                  <textarea class="form-control" rows="3" [ngClass]="{ 'is-touched': keyword }"
                  name="keyword" [(ngModel)]="keyword" maxlength="1000" placeholder="eg: PNRR"></textarea>
                </div>
                <div class="form-group col-md-2">
                  <div class="d-flex flex-column mt-4">
                    @if (keyword.length === 1000) {
                      <small class="text-danger">{{errorMessages.queryTooLong}}</small>
                    }
                    @if (wildcardInQuotes()) {
                      <small class="text-danger">{{errorMessages.wildcardInQuotes}}</small>
                    }
                    @if (!parenthesisAreEven()) {
                      <small class="text-danger">{{errorMessages.parenthesisAreEven}}</small>
                    }
                    @if (!doubleQuotesAreEven()) {
                      <small class="text-danger">{{errorMessages.doubleQuotesAreEven}}</small>
                    }
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-5">
                  <label>Users
                    <i class="fa fa-question-circle" data-bs-toggle="tooltip" data-placement="top" data-delay="300" title="Last name or username of the users to include"></i>
                    @if (person.length === 1000) {
                      <small class="text-danger ms-1">{{errorMessages.queryTooLong}}</small>
                    }
                  </label>
                  <input type="text" class="form-control" [ngClass]="{ 'is-touched': person }"
                    name="person" [(ngModel)]="person" maxlength="1000" placeholder="eg: Meloni">
                </div>
                <div class="form-group col-md-5">
                  <label>Exclude users
                    <i class="fa fa-question-circle" data-bs-toggle="tooltip" data-placement="top" data-delay="300" title="Last name or username of the users to exclude"></i>
                    @if (noperson.length === 1000) {
                      <small class="text-danger ms-1">{{errorMessages.queryTooLong}}</small>
                    }
                  </label>
                  <input type="text" class="form-control" [ngClass]="{ 'is-touched': noperson }"
                    name="noperson" [(ngModel)]="noperson" maxlength="1000" placeholder="eg: Lannutti">
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-10">
                  <label>Sources</label>
                  <i class="fa fa-question-circle ms-1" data-bs-toggle="tooltip" data-placement="top" data-delay="300" title="No source selected is equal to all sources"></i>
                  <div class="btn-group-toggle" data-bs-toggle="buttons">
                    @for (source of sourcesFixed; track source) {
                      <label class="btn btn-outline-primary me-1 mt-1 mt-sm-0" [ngClass]="{ 'active': sources.includes(source) }">
                        <input type="checkbox" name="searchSources" (change)="checkSource(source)" [checked]="sources.includes(source)">
                        {{formatSource(source)}} <i class="fa" [ngClass]="{ 'fa-square-o': !sources.includes(source), 'fa-check-square-o': sources.includes(source) }"></i>
                      </label>
                    }
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-3">
                  <label>Language</label>
                  <select class="form-control" [ngClass]="{ 'is-touched': lang }" name="lang" [(ngModel)]="lang">
                    <option value="">Any language</option>
                    <option value="en">English</option>
                    <option value="it" selected>Italian</option>
                  </select>
                </div>
                <div class="form-group col-md-4">
                  <label>Party</label>
                  <select class="form-control" [ngClass]="{ 'is-touched': party }" name="party" [(ngModel)]="party">
                    <option value="" selected>Any party</option>
                    <optgroup label="Italy">
                      @for (party of parties; track party) {
                        <option [value]="party._id">{{party.name}}</option>
                      }
                    </optgroup>
                    <optgroup label="EU">
                      @for (party of partiesEU; track party) {
                        <option [value]="party._id">{{party.name}}</option>
                      }
                    </optgroup>
                  </select>
                </div>
                <div class="form-group col-md-3">
                  <label>Date</label>
                  <select class="form-control" [ngClass]="{ 'is-touched': days }" name="days" [(ngModel)]="days">
                    <option value="1">Last day</option>
                    <option value="3">Last 3 days</option>
                    <option value="7">Last week</option>
                    <option value="30" selected>Last month</option>
                    <option value="90">Last 3 months</option>
                    <option value="180">Last 6 months</option>
                    <option value="365">Last year</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-3">
                  <label>Organ</label>
                  <i class="fa fa-question-circle ms-1" data-bs-toggle="tooltip" data-placement="top" data-delay="300" title="Politician's organ"></i>
                  <select class="form-control" [ngClass]="{ 'is-touched': organ }" name="organ" [(ngModel)]="organ">
                    <option value="" selected>Any organ</option>
                    @for (organ of organs; track organ) {
                      <option [value]="organ">{{organ}}</option>
                    }
                  </select>
                </div>
                <div class="form-group col-md-4">
                  <label>Commission</label>
                  <i class="fa fa-question-circle ms-1" data-bs-toggle="tooltip" data-placement="top" data-delay="300" title="Document or politician's commission"></i>
                  <select class="form-control" [ngClass]="{ 'is-touched': commission }" name="commission" [(ngModel)]="commission">
                    <option value="" selected>Any commission</option>
                    @for (commission of commissions; track commission) {
                      <option [value]="commission._id">
                        {{commission.roman}} - {{commission.name}} ({{commission.organ | flu}})
                      </option>
                    }
                  </select>
                </div>
                <div class="form-group col-md-3">
                  <label>MEP Country</label>
                  <i class="fa fa-question-circle ms-1" data-bs-toggle="tooltip" data-placement="top" data-delay="300" title="MEP Country (EU only)"></i>
                  <select class="form-control" [ngClass]="{ 'is-touched': country }" name="country" [(ngModel)]="country">
                    <option value="" selected>Any country</option>
                    @for (country of euCountries; track country) {
                      <option [value]="country">{{country}}</option>
                    }
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-12">
                  <button class="btn btn-primary" type="submit" [disabled]="isSearchDisabled()">
                    <i class="fa fa-search"></i> Search
                  </button>
                </div>
              </div>
            </form>
            @if (!isSearching) {
              <p class="small mt-1 hide-print">Perform a search to create a new alert below.</p>
            }
            <div [ngClass]="{'bg-light border rounded-lg px-3 pt-2 pb-1 hide-print': true, 'disabled': !isSearching || searchHasError }">
              <app-add-alert-form [keyword]="keyword" [person]="person" [noperson]="noperson" [source]="source"
                [lang]="lang" [party]="party" [organ]="organ" [commission]="commission" [country]="country"
              [isLoadingSearch]="isLoading.search"></app-add-alert-form>
            </div>
            <hr class="my-0 mb-2">
            @if (isSearching && !isLoading.search && results?.length) {
              <p>
                <span class="badge badge-primary">{{count}}</span> results found:
              </p>
            }
            <app-result [isLoading]="isLoading.search" [results]="results"></app-result>
            @if (results.length) {
              <div>
                <app-pagination [isLoading]="isLoading.search" [count]="count" [perPage]="perPage" [page]="page" eventName="getSearch"></app-pagination>
                <app-spinner [condition]="isLoading.search"></app-spinner>
              </div>
            }
          </div>
        </div>
      }
      <div class="card border-0" [hidden]="currentContent !== 'alerts' && currentContent !== 'my-alerts'">
        <h4 class="card-header border-0">
          Alerts <app-breadcrumb [menuItems]="menuItems" [currentContent]="currentContent"></app-breadcrumb>
        </h4>
        <app-alerts [commissions]="commissions"></app-alerts>
      </div>
      <div class="card border-0" [hidden]="currentContent !== 'stats'">
        <h4 class="card-header border-0">
          Search <app-breadcrumb [menuItems]="menuItems" [currentContent]="currentContent"></app-breadcrumb>
        </h4>
        <div class="card-body" [ngClass]="{ 'disabled': isLoading.stats || !isSearching }">
          @if (isLoading.stats && isSearching) {
            <p>
              <app-spinner [condition]="isLoading.stats"></app-spinner>
            </p>
          }
          @if (!isLoading.stats && (keyword || person)) {
            <div class="d-flex flex-column">
              <div class="mb-3">
                @if (keyword) {
                  <span>Keywords: <code>{{keyword}}</code><br></span>
                }
                @if (person) {
                  <span>Users: <code>{{person}}</code><br></span>
                }
                @if (noperson) {
                  <span>Exclude users: <code>{{noperson}}</code><br></span>
                }
                @if (source) {
                  <span>Source: <code>{{source}}</code><br></span>
                }
                @if (lang) {
                  <span>Language: <code>{{lang}}</code><br></span>
                }
                @if (organ) {
                  <span>Organ: <code>{{organ}}</code><br></span>
                }
                @if (commission) {
                  <span>Commission: <code>{{commission}}</code><br></span>
                }
                @if (country) {
                  <span>MEP Country: <code>{{country}}</code><br></span>
                }
                @if (days) {
                  <span>Days: <code>{{days}}</code><br></span>
                }
              </div>
            </div>
          }
          <div class="row">
            <div class="col-lg-6 mb-3">
              <div class="card h-100">
                <h5 class="card-header border-0">
                  Counts
                </h5>
                <div class="card-body d-flex flex-row justify-content-around">
                  <div class="text-center">
                    <h4>{{count}}</h4>
                    total results
                  </div>
                  <div class="text-center">
                    <h4>{{statsResults.count || 0}}</h4>
                    tweets
                  </div>
                  <div class="text-center">
                    <h4>{{statsResults.countUsers || 0}}</h4>
                    unique users
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 mb-3">
              <div class="card h-100">
                <h5 class="card-header border-0">
                  Category
                </h5>
                <div class="card-body d-flex flex-row justify-content-around">
                  <div class="text-center">
                    <h4>{{statsResults.categories?.institutions || 0}}%</h4>
                    <i class="fa fa-suitcase"></i> institutions
                  </div>
                  <div class="text-center">
                    <h4>{{statsResults.categories?.media || 0}}%</h4>
                    <i class="fa fa-video-camera"></i> media
                  </div>
                  <div class="text-center">
                    <h4>{{statsResults.categories?.corporate || 0}}%</h4>
                    <i class="fa fa-user"></i> third parties
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 mb-3">
              <div class="card h-100">
                <h5 class="card-header border-0">
                  Top users (institutions)
                  <a class="small float-end" [routerLink]="" (click)="exportChart(barChartTopUsersInstitutions, 'top_users_institutions')"
                    data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download chart">
                    <i class="fa fa-download"></i>
                  </a>
                  <a class="small float-end me-3" [routerLink]="" (click)="downloadCSV('usersInstitutions', 'username,posts')"
                    data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download CSV">
                    <i class="fa fa-database"></i>
                  </a>
                  <div class="btn-group me-3 float-end" role="group">
                    <button class="btn btn-sm btn-outline-primary" (click)="getStatsByModelSkip('prev', 'usersInstitutions')" [disabled]="skip.usersInstitutions <= 0">
                      <i class="fa fa-chevron-left"></i>
                    </button>
                    <button class="btn btn-sm btn-outline-secondary cursor-default">
                      {{skip.usersInstitutions}} to {{skip.usersInstitutions + 10}}
                    </button>
                    <button class="btn btn-sm btn-outline-primary" (click)="getStatsByModelSkip('next', 'usersInstitutions')" [disabled]="skip.usersInstitutions >= 50">
                      <i class="fa fa-chevron-right"></i>
                    </button>
                  </div>
                </h5>
                <div class="card-body">
                  <canvas id="bar-chart1"></canvas>
                </div>
              </div>
            </div>
            <div class="col-lg-6 mb-3">
              <div class="card h-100">
                <h5 class="card-header border-0">
                  Top users (media)
                  <a class="small float-end" [routerLink]="" (click)="exportChart(barChartTopUsersMedia, 'top_users_media')"
                    data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download chart">
                    <i class="fa fa-download"></i>
                  </a>
                  <a class="small float-end me-3" [routerLink]="" (click)="downloadCSV('usersMedia', 'username,posts')"
                    data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download CSV">
                    <i class="fa fa-database"></i>
                  </a>
                  <div class="btn-group me-3 float-end" role="group">
                    <button class="btn btn-sm btn-outline-primary" (click)="getStatsByModelSkip('prev', 'usersMedia')" [disabled]="skip.usersMedia <= 0">
                      <i class="fa fa-chevron-left"></i>
                    </button>
                    <button class="btn btn-sm btn-outline-secondary cursor-default">
                      {{skip.usersMedia}} to {{skip.usersMedia + 10}}
                    </button>
                    <button class="btn btn-sm btn-outline-primary" (click)="getStatsByModelSkip('next', 'usersMedia')" [disabled]="skip.usersMedia >= 50">
                      <i class="fa fa-chevron-right"></i>
                    </button>
                  </div>
                </h5>
                <div class="card-body">
                  <canvas id="bar-chart2"></canvas>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 mb-3">
              <div class="card h-100">
                <h5 class="card-header border-0">
                  Organs
                </h5>
                <div class="card-body d-flex flex-row justify-content-around">
                  <div class="text-center">
                    <h4>{{statsResults.organs?.camera || 0}}%</h4>
                    <img class="img-20 img-rounded" [src]="profilePics.camera" alt=""> Deputies
                  </div>
                  <div class="text-center">
                    <h4>{{statsResults.organs?.senato || 0}}%</h4>
                    <img class="img-20 img-rounded" [src]="profilePics.senato" alt=""> Senators
                  </div>
                  <div class="text-center">
                    <h4>{{statsResults.organs?.european_parliament || 0}}%</h4>
                    <img class="img-20 img-rounded" [src]="profilePics.eu" alt=""> MEPs
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 mb-3">
              <div class="card h-100">
                <h5 class="card-header border-0">
                  Gender
                </h5>
                <div class="card-body d-flex flex-row justify-content-around">
                  <div class="text-center">
                    <h4>{{statsResults.genders?.male || 0}}%</h4>
                    <i class="fa fa-male h3"></i>
                  </div>
                  <div class="text-center">
                    <h4>{{statsResults.genders?.female || 0}}%</h4>
                    <i class="fa fa-female h3"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 mb-3">
              <div class="card h-100">
                <h5 class="card-header border-0">
                  Top commissions
                  <a class="small float-end" [routerLink]="" (click)="exportChart(barChartTopCommissions, 'top_commissions')"
                    data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download chart">
                    <i class="fa fa-download"></i>
                  </a>
                  <a class="small float-end me-3" [routerLink]="" (click)="downloadCSV('commissions', 'commission,posts')"
                    data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download CSV">
                    <i class="fa fa-database"></i>
                  </a>
                  <div class="btn-group me-3 float-end" role="group">
                    <button class="btn btn-sm btn-outline-primary" (click)="getStatsByModelSkip('prev', 'commissions')" [disabled]="skip.commissions <= 0">
                      <i class="fa fa-chevron-left"></i>
                    </button>
                    <button class="btn btn-sm btn-outline-secondary cursor-default">
                      {{skip.commissions}} to {{skip.commissions + 10}}
                    </button>
                    <button class="btn btn-sm btn-outline-primary" (click)="getStatsByModelSkip('next', 'commissions')" [disabled]="skip.commissions >= 50">
                      <i class="fa fa-chevron-right"></i>
                    </button>
                  </div>
                </h5>
                <div class="card-body">
                  <canvas id="bar-chart4"></canvas>
                </div>
              </div>
            </div>
            <div class="col-lg-6 mb-3">
              <div class="card h-100">
                <h5 class="card-header border-0">
                  Top parties
                  <a class="small float-end" [routerLink]="" (click)="exportChart(barChartTopParties, 'top_parties')"
                    data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download chart">
                    <i class="fa fa-download"></i>
                  </a>
                  <a class="small float-end me-3" [routerLink]="" (click)="downloadCSV('parties', 'party,posts')"
                    data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download CSV">
                    <i class="fa fa-database"></i>
                  </a>
                </h5>
                <div class="card-body">
                  <canvas id="bar-chart3"></canvas>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 mb-3">
              <div class="card h-100">
                <h5 class="card-header border-0">
                  Top followers
                  <a class="small float-end" [routerLink]="" (click)="exportChart(barChartTopUsersFollowers, 'top_followers')"
                    data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download chart">
                    <i class="fa fa-download"></i>
                  </a>
                  <a class="small float-end me-3" [routerLink]="" (click)="downloadCSV('usersFollowers', 'username,followers')"
                    data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download CSV">
                    <i class="fa fa-database"></i>
                  </a>
                  <div class="btn-group me-3 float-end" role="group">
                    <button class="btn btn-sm btn-outline-primary" (click)="getStatsByModelSkip('prev', 'usersFollowers')" [disabled]="skip.usersFollowers <= 0">
                      <i class="fa fa-chevron-left"></i>
                    </button>
                    <button class="btn btn-sm btn-outline-secondary cursor-default">
                      {{skip.usersFollowers}} to {{skip.usersFollowers + 10}}
                    </button>
                    <button class="btn btn-sm btn-outline-primary" (click)="getStatsByModelSkip('next', 'usersFollowers')" [disabled]="skip.usersFollowers>= 50">
                      <i class="fa fa-chevron-right"></i>
                    </button>
                  </div>
                </h5>
                <div class="card-body">
                  <canvas id="bar-chart5"></canvas>
                </div>
              </div>
            </div>
            <div class="col-lg-6 mb-3">
              <div class="card h-100">
                <h5 class="card-header border-0">
                  Top words
                  <a class="small float-end" [routerLink]="" (click)="exportChart(barChartTopWords, 'top_words')"
                    data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download chart">
                    <i class="fa fa-download"></i>
                  </a>
                  <a class="small float-end me-3" [routerLink]="" (click)="downloadCSV('topWords', 'word,occurrences')"
                    data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download CSV">
                    <i class="fa fa-database"></i>
                  </a>
                </h5>
                <div class="card-body">
                  <canvas id="bar-chart6"></canvas>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 mb-3">
              <div class="card h-100">
                <h5 class="card-header border-0">
                  Sentiment distribution
                  <i class="fa fa-info-circle small" data-bs-toggle="tooltip" data-placement="top" data-delay="350" title="Unknown values are not shown"></i>
                  <a class="small float-end" [routerLink]="" (click)="exportChart(donutChartSentiment, 'sentiment')"
                    data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download chart">
                    <i class="fa fa-download"></i>
                  </a>
                  <a class="small float-end me-3" [routerLink]="" (click)="downloadCSV('sentiment', 'sentiment,posts')"
                    data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download CSV">
                    <i class="fa fa-database"></i>
                  </a>
                </h5>
                <div class="card-body">
                  <canvas id="donut-chart1"></canvas>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <app-search-query-info-modal></app-search-query-info-modal>
  <app-other-sources-info-modal></app-other-sources-info-modal>